
import React, { useEffect } from "react";
import { Separator } from "../../ui/separator";

const CookiesAndIPPolicy = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="flex-grow bg-white py-8 md:py-12">
      <div className="container mx-auto px-2 md:px-4">
        <div className="max-w-4xl mx-auto">
          {/* Page Header */}
          <div className="mb-8 md:mb-12">
            <h1 className="text-3xl font-bold mb-6 text-center text-[#523880]">
              Cookie & Intellectual Property Policy
            </h1>
            <p className="text-sm text-gray-500 text-center mb-8">
              Effective Date: Jun 02, 2025
            </p>
          </div>

          {/* Content */}
          <div className="prose prose-lg max-w-none">
            <p className="font-semibold mb-6 text-base leading-relaxed text-gray-800">
              TTL Media Pvt. Ltd. ("Oye Creators")
            </p>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mt-8 mb-4 text-[#EE3788]">
                Article 1 – Definitions
              </h2>
              <p className="text-base leading-relaxed text-gray-800">
                1.1 "Admin" means any employee or contractor of Oye Creators
                granted access to the Platform for support, quality control,
                or enforcement of this Policy.
              </p>
              <p className="text-base leading-relaxed text-gray-800">
                1.2 "Client" or "Enterprise Client" means any business,
                organization or individual that contracts with Oye Creators to
                procure Creator Content.
              </p>
              <p className="text-base leading-relaxed text-gray-800">
                1.3 "Content" means any text, graphics, images, video, scripts
                or other materials uploaded, posted or otherwise provided by a
                Creator.
              </p>
              <p className="text-base leading-relaxed text-gray-800">
                1.4 "Creator" means any individual or entity that submits or
                generates Content via the Platform.
              </p>
              <p className="text-base leading-relaxed text-gray-800">
                1.5 "Platform" or "Service" means the website, applications
                and APIs of Oye Creators.
              </p>
              <p className="text-base leading-relaxed text-gray-800">
                1.6 "Policy" means this combined Cookie & Intellectual
                Property Policy.
              </p>
              <p className="text-base leading-relaxed text-gray-800">
                1.7 "Third-Party Cookie" means any cookie set by a domain
                other than oyecreators.com.
              </p>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4 text-[#EE3788]">
                Article 2 – Scope & Applicability
              </h2>
              <p className="mb-4">
                This Policy applies to all users of the Platform, including
                Creators, Clients, Admins, and any visitor who accesses or
                uses the Service.
              </p>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-bold mb-4 text-[#EE3788]">
                Article 3 – Cookie Policy
              </h2>
              <p className="mb-4">
                <strong>3.1 Use of Cookies.</strong> Oye Creators employs
                cookies and similar technologies to authenticate and maintain
                user sessions, measure and improve Site performance,
                personalize content and advertising, and remember user
                preferences.
              </p>
              <p className="mb-4">
                <strong>3.2 Types of Cookies.</strong> The following
                categories of cookies are used:
              </p>
              <p className="mb-4 ml-4">
                Essential Cookies: Core functionality (authentication,
                security). Contractual necessity. Session retention.
              </p>
              <p className="mb-4 ml-4">
                Analytical & Performance Cookies: Aggregate usage data to
                optimize performance. Legitimate interest. Up to 24 months.
              </p>
              <p className="mb-4 ml-4">
                Functional Cookies: Store user preferences (language, region).
                Consent or legitimate interest. Up to 12 months.
              </p>
              <p className="mb-4 ml-4">
                Marketing & Advertising Cookies: Deliver and measure targeted
                advertising. Consent. Up to 24 months.
              </p>
              <p className="mb-4">
                <strong>3.3 Managing Cookies.</strong> On first visit, a
                banner allows acceptance or rejection of non-essential
                cookies. Browser settings permit blocking or deletion of
                cookies. Opt-out links include Google Analytics opt-out and
                Facebook Ads settings.
              </p>
              <p className="mb-4">
                <strong>3.4 Detailed Cookie Inventory:</strong>
              </p>
              <p className="mb-4 ml-4">
                oc_session (Essential): Maintains login session; Expiry:
                Session
              </p>
              <p className="mb-4 ml-4">
                _ga (Analytical): Distinguishes users across sessions; Expiry:
                2 years
              </p>
              <p className="mb-4 ml-4">
                _gid (Analytical): Distinguishes users within 24 hours;
                Expiry: 24 hours
              </p>
              <p className="mb-4 ml-4">
                locale (Functional): Remembers language preference; Expiry: 12
                months
              </p>
              <p className="mb-4 ml-4">
                fbp (Marketing): Facebook Ads identifier; Expiry: 3 months
              </p>
              <p className="mb-4">
                <strong>3.5 Third-Party Cookies.</strong> Third-Party Cookies
                set by embedded services (e.g., social widgets) are governed
                by their own privacy practices.
              </p>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-bold mb-4 text-[#EE3788]">
                Article 4 – Intellectual Property Policy
              </h2>
              <p className="mb-4">
                <strong>4.1 Platform Intellectual Property</strong>
              </p>
              <p className="mb-4">
                All software, designs, trademarks, logos, documentation and
                related intellectual property comprising the Platform are and
                remain the exclusive property of TTL Media Pvt. Ltd.
              </p>
              <p className="mb-4">
                <strong>4.2 Assignment of Creator Content</strong>
              </p>
              <p className="mb-4">
                By submitting Content, each Creator irrevocably assigns to Oye
                Creators all worldwide rights, title and interest (including
                copyright and moral rights) in such Content, without further
                consideration.
              </p>
              <p className="mb-4">
                <strong>4.3 Client Materials</strong>
              </p>
              <p className="mb-4">
                Clients retain ownership of any materials they supply. Oye
                Creators and Creators may use such materials solely to perform
                the agreed campaign.
              </p>
              <p className="mb-4">
                <strong>4.4 License to Clients</strong>
              </p>
              <p className="mb-4">
                Oye Creators grants each Client a non-exclusive, revocable,
                royalty-free, worldwide license to use Creator Content solely
                for the specific campaign and deliverables set forth in
                writing. Any use beyond the licensed scope requires prior
                written permission.
              </p>
              <p className="mb-4">
                <strong>4.5 Exclusive Licensing</strong>
              </p>
              <p className="mb-4">
                Clients desiring exclusivity must execute a separate written
                agreement specifying territory, media, duration and
                compensation.
              </p>
              <p className="mb-4">
                <strong>4.6 Admin Access</strong>
              </p>
              <p className="mb-4">
                Admins may access Content only for Platform operations,
                support, quality control, and enforcement of this Policy. Any
                other use is prohibited.
              </p>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-bold mb-4 text-[#EE3788]">
                Article 5 – Infringement & Takedown Procedure
              </h2>
              <p className="mb-4">
                Oye Creators implements notice-and-takedown procedures under
                DMCA (17 U.S.C. § 512), EU Copyright Directive (2001/29/EC),
                and India Copyright Act, 1957. To report infringement, submit
                written notice to dpo@oyecreators.com. Counter-notice rights
                are preserved.
              </p>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-bold mb-4 text-[#EE3788]">
                Article 6 – Warranties & Indemnification
              </h2>
              <p className="mb-4">
                <strong>6.1 Creator Warranties:</strong> Creators warrant they
                have all necessary rights to assign Content free of
                third-party claims.
              </p>
              <p className="mb-4">
                <strong>6.2 Client Warranties:</strong> Clients warrant their
                use of licensed Content will comply strictly with this Policy.
              </p>
              <p className="mb-4">
                <strong>6.3 Indemnification:</strong> Each party agrees to
                indemnify Oye Creators and the other party against any loss,
                liability, or expense arising from breach of these warranties.
              </p>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-bold mb-4 text-[#EE3788]">
                Article 7 – Governing Law & Jurisdiction
              </h2>
              <p className="mb-4">
                This Policy is governed by the laws of India (Copyright Act,
                1957; IT Act, 2000; Digital Personal Data Protection Act,
                2023) and, where applicable, EU/EEA law (ePrivacy Directive;
                GDPR; Directive 2001/29/EC; Regulation (EU) 2019/790).
                Disputes are subject to the exclusive jurisdiction of courts
                in Pune, Maharashtra, India.
              </p>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-bold mb-4 text-[#EE3788]">
                Article 8 – Amendments
              </h2>
              <p className="mb-4">
                Oye Creators may amend this Policy at any time by posting a
                revised version with a new Effective Date. Continued use of
                the Platform constitutes acceptance of the amended Policy.
              </p>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-bold mb-4 text-[#EE3788]">
                Article 9 – Contact
              </h2>
              <p className="mb-4">Data Protection Officer</p>
              <p className="mb-1">TTL Media Pvt. Ltd. (Oye Creators)</p>
              <p className="mb-1">Email: dpo@oyecreators.com</p>
              <p className="mb-1">Address: Quantum Works, CTS No. 177 p, metro station, S. No. 43/2, near Nal stop, Pandurang Colony, Erandwane, Pune, Maharashtra 411004</p>
            </section>
          </div>
        </div>
      </div>
    </main>
  );
};

export default CookiesAndIPPolicy;
